export const iconColourConfig = {
  Black: "var(--color-base-black)",
  Brand: "var(--color-brand-mid)",
};
